const getVideos = state => state.videoList.data;
const getVideosLoading = state => state.videoList.loading;
const getVideosError = state => state.videoList.error;
export { getVideos, getVideosLoading, getVideosError };



// WEBPACK FOOTER //
// ./src/selectors/videos.js